'use strict'

require '../../../../../core/frontend/groupon_modules/ariaKeyNavigation'
changeUserLanguage = require '../../../../../core/frontend/groupon_modules/changeUserLanguage'


module.exports = class extends Groupon.AriaMenuNavigation
  constructor: ->
    @$trigger = $('#ls-lang-selected')

    if @$trigger.length
      @$list = $('#ls-lang-list, #ls-lang-list-mobile')
      @$links = @$list.find('.lang-list-item')
      @$html = $('html')
      @hovTimeout = 0
      @bind()

  bind: ->
    startTimer  = => @hovTimeout = setTimeout( (=> @hideMenu()), 150)
    cancelTimer = => clearTimeout @hovTimeout

    @$list.on
      'mouseenter': ->
        cancelTimer()
        return
      'mouseleave': ->
        startTimer()
        return

    @$trigger.on(
      'mouseenter': =>
        cancelTimer()
        @$trigger.off('touchstart')
        if not @$list.is(':visible') # needed in case the mouse moves from the menu back to the $trigger
          @$trigger.trigger('tap')
        return

      'mouseleave': ->
        startTimer()
        return

      'tap': (e) =>
        e.preventDefault()
        e.stopImmediatePropagation()
        if not @$list.is(':visible')
          @showMenu()
          # register closing event once
          @setGlobalHideEvent()
        else
          @hideMenu()
        return

    ).one('touchstart', =>
      # remove web events just once
      @$trigger.add(@$list).off('mouseenter mouseleave')
    )

    @initMenuNavigation(@$trigger, @$list, @$links)

    @$links.on 'click', (e) ->
      e.preventDefault()
      e.stopImmediatePropagation()
      language = $(this).data('locale')
      changeUserLanguage language

  showMenu: ->
    @$trigger.addClass('ls-active')
    @$list.attr( 'aria-hidden', 'false').show()

  hideMenu: ->
    @$list.attr({'aria-hidden': 'true'}).hide()
    @$trigger.blur().removeClass('ls-active')

  setGlobalHideEvent: ->
    @$html.one 'tap', (e) =>
      if not $(e.target).closest('.lang-menu').length
        @hideMenu()
